import AlertBanner from '@/components/Banner/AlertBanner';
import type { Banner } from '@/models/types';
import { Stack } from '@mantine/core';
import { useMemo } from 'react';

type Props = {
  items?: Banner[];
};

const AlertBannerList = ({ items }: Props) => {
  const orderedItems = useMemo(() => {
    if (!items || items.length === 0) {
      return [];
    }
    return [...items].sort((a, b) => {
      const sortA = a.sort ?? 0;
      const sortB = b.sort ?? 0;
      return sortA - sortB;
    });
  }, [items]);

  if (orderedItems.length === 0) {
    return null;
  }

  return (
    <Stack mb="md">
      {orderedItems.map(item => (
        <AlertBanner key={item.id} item={item} />
      ))}
    </Stack>
  );
};

export default AlertBannerList;
